import { withTiming } from '@common/core/utils/withTiming'

import type { Workspace } from '../types'
import {
  createWorkspace as _createWorkspace,
  getWorkspacesByUserId as _getWorkspacesByUserId,
  updateLastUsedProject as _updateLastUsedProject,
} from '../workspaces'

import { useWorkspacesStore } from './workspaces.store'

export const getWorkspacesByUserId = withTiming('getWorkspacesByUserId', async (): Promise<void> => {
  const { setState } = useWorkspacesStore.getState()
  setState({ loading: true, error: null })
  try {
    const data = await _getWorkspacesByUserId()
    setState({ workspaces: data })
  } catch (err) {
    setState({ workspaces: [] })
    throw err
  } finally {
    setState({ loading: false })
  }
})

// TODO: connect with current workspace when backend ready
export function getCurrentWorkspace(): Workspace | null {
  const { workspaces } = useWorkspacesStore.getState()
  const workspace = workspaces[0] ?? null
  useWorkspacesStore.getState().setState({ currentWorkspace: workspace })
  return workspace
}

export const createWorkspace = withTiming('createWorkspace', async (workspaceName: string): Promise<string | null> => {
  const { setState } = useWorkspacesStore.getState()
  try {
    setState({ loading: true, error: null })
    return await _createWorkspace(workspaceName)
  } finally {
    setState({ loading: false })
  }
})

export const updateLastUsedProject = withTiming(
  'updateLastUsedProject',
  async (workspaceId: string, lastUsedProjectId: string): Promise<void> => {
    try {
      await _updateLastUsedProject(workspaceId, lastUsedProjectId)
    } catch (error) {
      console.error('Failed to update last used project:', error)
    }
  }
)
